import { render, staticRenderFns } from "./jmsSCZXBCXY.vue?vue&type=template&id=52caa4a0"
import script from "./jmsSCZXBCXY.vue?vue&type=script&lang=js"
export * from "./jmsSCZXBCXY.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports